import React from "react";

const UserAvatar = ({
    src,
    alt = "User",
    className = "",
    size = 44,
}) => {
    const fallback = "/avatars/kuddlecorebear.png";

    return (
        <img
            src={src || fallback}
            alt={alt}
            className={className}
            style={{
                width: size,
                height: size,
                borderRadius: "50%",
                objectFit: "cover",
            }}
            onError={(e) => {
                e.currentTarget.src = fallback;
            }}
        />
    );
};

export default UserAvatar;